/*!
 * Creates elements that will fire events for the google translate widget
 */
(function($) {

	var language = '';
	function changeGoogleTranslate() {
		setTimeout(changeGoogleTranslate, 100);

		var lang = $('.goog-te-menu-value span:first-child').text();
		if(language != lang ) {
			flags( lang );
		}

 	}

 	function fireEvent(element,event){
 		if (document.createEventObject){
 			var evt = document.createEventObject();
 			return element.fireEvent('on'+event,evt)
 		}
 		else{
 			var evt = document.createEvent("HTMLEvents");
 			evt.initEvent(event, false, true );
 			return !element.dispatchEvent(evt);
 		}
 	}

 	changeGoogleTranslate();

 	function flags( k ) {
 		language = k;
 		var opt = {
 			'Select Language': 'usa',
			'English': 'usa',
			'Arabic': 'uae',
			'Armenian': 'armenia',
			'Chinese (Simplified)': 'china',
			'Chinese (Traditional)': 'china',
			'Danish': 'denmark',
			'Dutch': 'netherlands',
			'French': 'france',
			'German': 'germany',
			'Greek': 'greece',
			'Hebrew': 'israel',
			'Hindi': 'india',
			'Italian': 'italy',
			'Japanese': 'japan',
			'Norwegian': 'norway',
			'Russian': 'russia',
			'Spanish': 'mexico',
			'Swedish': 'sweden',
			'Thai': 'thailand',
			'Turkish': 'turkey',
			'Vietnamese': 'vietnam'
 		}

 		// console.log ('she says: '+ opt[k]);
 		$('.goog-te-menu-value').attr('class', 'goog-te-menu-value ' + opt[k]);
 		

 	}

	 		



})(jQuery);

//*/